import { toast } from "react-toastify";
import PlantQuotas from "../../../api/plant-quotas";
import Quotas from "../../../api/quotas";
import QuotasServices from "./services";

export const quotas = {
  state: {
    quotas: [],
    availablePlantQuotas: [],
    loading: false,
  },
  reducers: {
    setEditQuotaQuantity(state, payload) {
      return {
        ...state,
        quotas: state.quotas.map(item => {
          if((item.fe_id === payload.row.fe_id) && (item.transporter_document === payload.row.transporter_document)) {
            return {
              ...item,
              dates: item.dates.map(subItem => {
                if(subItem.date === payload.weekDay){
                  return {
                    ...subItem,
                    allocated: parseInt(payload.value) || 0
                  }
                } else {
                  return subItem;
                }
              })
            }
          } else {
            return item;
          }
        })
      };
    },
    setAddquantity(state, payload) {
      return {
        ...state,
        quotas: state.quotas.map(item => {
          if((item.fe_id === payload.row.fe_id) && (item.transporter_document === payload.row.transporter_document)) {
            return {
              ...item,
              dates: item.dates.map(subItem => {
                if(subItem.date === payload.weekDay){
                  return {
                    ...subItem,
                    allocated: subItem.allocated + 1
                  }
                } else {
                  return subItem;
                }
              })
            }
          } else {
            return item;
          }
        })
      };
    },
    setSubtractquantity(state, payload) {
      return {
        ...state,
        quotas: state.quotas.map(item => {
          if((item.fe_id === payload.row.fe_id) && (item.transporter_document === payload.row.transporter_document)) {
            return {
              ...item,
              dates: item.dates.map(subItem => {
                if(subItem.date === payload.weekDay && subItem.allocated > 0){
                  return {
                    ...subItem,
                    allocated: subItem.allocated - (payload.alreadyScheduled?? 1)
                  }
                } else {
                  return subItem;
                }
              })
            }
          } else {
            return item;
          }
        })
      };
    },
    setQuotas(state, payload) {
      return {
        ...state,
        availableDays: payload.availableDays,
        quotas: payload.quotas.map(item => {
          return {
            ...item,
            fe_id: Math.floor(Math.random() * 100000),
            dates: item.dates.map(subItem => {
              return {
                ...subItem,
                available: payload.availableDays
                  .map(element => {
                    if(element.date === subItem.date) {
                      return element.available
                    } else {
                      return null;
                    }
                  })
                  .filter(element => !!element)[0] ?? 0
              }
            })
          }
        }),
      };
    },
    setClonedQuotas(state, payload) {
      return {
        ...state,
        availableDays: payload.availableDays,
        quotas: payload.quotas.map( item => {
          item.dates.map( dateData => {
            dateData.available = payload.availableDays
            .map(element => {
              if(element.date === dateData.date) {
                return element.available
              } else {
                return null;
              }
            })
            .filter(element => !!element)[0] ?? 0
            return true;
          })

          return {
            ...item,
            fe_id: Math.floor(Math.random() * 100000),
            dates: item.dates
          }
        })
      }
    },
    setAvailablePlantQuotas(state, payload) {
      return {
        ...state,
        availablePlantQuotas: payload,
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    clearStore() {
      return {};
    },
    setClearClientQuotas(state, payload) {
      return {...state, quotas: state.quotas.map((item) => {
        return {...item, dates: item.dates.map((subItem) => {
          return {
            ...subItem,
            allocated: payload.dates.includes(subItem.date) && payload.fe_id === item.fe_id ? 0 : subItem.allocated
          }
        })}
      })}
    },
    setAddNewClientQuota(state, payload) {
      return {
        ...state,
        quotas: [
          ...state.quotas,
          {
            ...payload,
            dates: payload.dates.map(item => {
              return {
                ...item,
                available: state.availableDays.map(element => {
                  if(element.date === item.date) {
                    return element.available
                  } else {
                    return null;
                  }
                })
                .filter(element => !!element)[0] ?? 0
              }
            })
          }
        ]
      }
    }
  },
  effects: (dispatch) => ({
    async sendContent(item) {

      this.loading({ loading: true });
      try {

        await Quotas.multipleSave(item);
        this.loading({ loading: false });
        dispatch.dialogs.setConfirmDialogAsync({
          isOpen: true,
          title: "Configurações salvas com sucesso!",
        });
        return {success: true, data: null};
      } catch (error) {
        this.loading({ loading: false });
        if (error?.response?.data) {
          return { success: false, data: error.response.data };
        } else {
          toast.error("Ops :( Algo deu errado !");
        }
      }
    },
    async addQuantity(item) {
      return this.setAddquantity(item);
    },
    async subtractQuantity(item) {
      return this.setSubtractquantity(item);
    },
    async loadAvailableQuotas(payload, rootState) {
      this.loading({ loading: true });
      const { idBranch, date, idTimeBlock, idPlant } = payload;
      try {
        const res = await PlantQuotas.list(
          idBranch,
          date,
          idTimeBlock,
          idPlant
        );
        const { data } = res;
        const plantQuotas = data.filter((quota) => quota.deleted !== true);
        this.setAvailablePlantQuotas(plantQuotas);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async getOnlyDataQuotasByWeek(payload, rootState) {
      try {
        if (payload) {
          const { idPlant, startDate, endDate, idTimeBlock } = payload;
          return await Quotas.listByClient(idPlant, startDate, endDate, idTimeBlock);
        }
      } catch (error) {
        toast.error("Ops :( Algo deu errado na listagem !");
        return { success: false, message: "Erro ao listar cotas." };
      }
    },     
    async cloneQuotasFromLastWeek(payload, rootState) {
      try {
        this.loading({ loading: true });
        const todayDate = new Date().toLocaleDateString('en-CA');

        const { structuredClonedQuotas, thisWeekQuotasData } = await QuotasServices.getLastAndThisWeekQuotas(payload)

        await QuotasServices.handleThisWeekQuotas(structuredClonedQuotas, thisWeekQuotasData);
        await QuotasServices.handleSchedulingsFromThisWeek(structuredClonedQuotas);

        const hasDisabledDaysOnThisWeek = thisWeekQuotasData.availableDays.filter( days => {
          return days.date < todayDate
        })

        if(thisWeekQuotasData.quotas.length && hasDisabledDaysOnThisWeek.length) {
          const clonedQuotas = structuredClonedQuotas.quotas;
          const weekQuotas = thisWeekQuotasData.quotas;

          //Extrat the client_Id from clonedQuotas to a new id array
          const clonedQuotasClientId = clonedQuotas.map( element => {
            return element.client_id
          });

          //Extrat the client_Id from weekQuotas to a new id array
          const weekQuotasClientId = weekQuotas.map( element => {
            return element.client_id
          });

          //Intercept diference between weekQuotas and ClonedQuotas
          const quotaDifference = weekQuotasClientId.filter(x => !clonedQuotasClientId.includes(x));

          //Search if weekquotas has quotaDiference and put in structoredClonedQuotas
          if(quotaDifference.length) {
            weekQuotas.forEach(quota => {
              if(quotaDifference.includes(quota.client_id)) {
                quota.dates.map(date => {
                  if(date.date >= todayDate) {
                    date.allocated = 0
                  }
                  return true;
                })

                return structuredClonedQuotas.quotas.push(quota)
              }
            })
          }
        }
        this.setClonedQuotas(structuredClonedQuotas);
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado na listagem !");
        return { success: false, message: "Erro ao listar cotas." };
      }
      this.loading({ loading: false });
      return { success: true, message: "Cotas listadas com sucesso." };
    },
    async loadAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        let data = [];
        if (payload) {
          const { idPlant, startDate, endDate, idTimeBlock } = payload;
          const res = await Quotas.listByClient(idPlant, startDate, endDate, idTimeBlock);
          data = res.data;
        }
        this.setQuotas(data);
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado na listagem !");
        return { success: false, message: "Erro ao listar cotas." };
      }
      this.loading({ loading: false });
      return { success: true, message: "Cotas listadas com sucesso." };
    },
    async addAsync(payload, rootState) {
      try {
        this.loading({ loading: true });

        await Quotas.addEmptyQuota(payload.quota);

        this.loadAsync(payload.filter);
      } catch (error) {
        let message = "Erro ao adicionar cota.";
        if (error.response && error?.response.data) {
            if(Array.isArray(error?.response.data)){
               message = error?.response.data[0];
            }else{
               message = error?.response.data;
            }
        }
        this.loading({ loading: false });
        return { success: false, message};
      }
      this.loading({ loading: false });
      return { success: true, message: "Cota adicionada com sucesso." };
    },
    async updateAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          quotas: { quotas },
        } = rootState;
        const { data } = await Quotas.update(payload);
        this.setQuotas(quotas.map((b) => (b.id === data.id ? data : b)));
      } catch (error) {
        this.loading({ loading: false });
        return { success: false, message: "Erro ao atualizar cota." };
      }
      this.loading({ loading: false });
      return { success: true, message: "Cota atualizada com sucesso." };
    },
    async deleteAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        await Quotas.delete(payload);
        const {
          quotas: { quotas },
        } = rootState;
        this.setQuotas(quotas.filter((p) => p.id !== payload));
      } catch (error) {
        this.loading({ loading: false });
        return { success: false, message: "Erro ao remover cota." };
      }
      this.loading({ loading: false });
      return { success: true, message: "Cota removida com sucesso." };
    },
    async clearClientQuotas (payload, rootState) {
      return this.setClearClientQuotas(payload, rootState)
    },
    async addNewClientQuota (payload, rootState) {
      await this.handleSchedulesFromNewQuotas(payload, rootState);

      return this.setAddNewClientQuota(payload, rootState)
    },
    async handleSchedulesFromNewQuotas(payload, rootState) {
      const todayDate = new Date().toLocaleDateString('en-CA');
      const { dates } = payload;
      const { quotas } = rootState.quotas;

      const schedulings = await QuotasServices.getQuotaSchedulings(payload);

      //Apply de schedules on allocated and alreadyScheduled variables
      dates.map( weekDay => {
        weekDay.allocated = 0
        weekDay.alreadyScheduled = 0

        if(weekDay.date < todayDate) {
          return true;
        }

        const schedules = QuotasServices.filterSchedulingsByDate(schedulings, payload, weekDay.date)

        //Validates if this client is already in state, if so, returns the client
        const quotaAlreadyInState = QuotasServices.checkIfClientIsAlreadyInState(quotas, payload);

        if(schedules.length > 0) {
          weekDay.allocated = schedules[0].qty
          weekDay.alreadyScheduled = schedules[0].qty

          //Decreases the number of queries that will be cleared on the new client
          if(payload.transporter_document.length > 0) {
            const principalQuota = QuotasServices.handleIfQuotaAlreadyExists(quotaAlreadyInState, weekDay, schedules, payload.client_document)

            if(principalQuota) {
              const { date, item } = principalQuota;

              if(date.allocated > date.alreadyScheduled) {
                this.subtractQuantity(item);
              }
            }
          } 

          if(payload.transporter_document.length < 1) {
            //Client without transporter
            const scheduleQty = schedules.reduce( function(total, currentValue) {
              //check if has another client with transporter document on state to skip the qtantity from quotas reservation
              const skipQty = quotaAlreadyInState.find( function({transporter_document}) {
                if(transporter_document === currentValue.transporter_document) {
                  return true;
                }
                return false;
              })

              if(!skipQty) { 
                return total += currentValue.qty;
              }

              return total;
            }, 0);

            weekDay.allocated = weekDay.alreadyScheduled = scheduleQty;
          }
        }

        return true;
      });
    },
    async editQuotaQuantity (payload, rootState) {
      return this.setEditQuotaQuantity(payload, rootState)
    }
  }),
};
